import React from 'react';
import { useSelector } from 'react-redux';
import { getSecurityUiConfig } from '../../../../base/config/functions.any';
import { isLocalParticipantModerator } from '../../../../base/participants/functions';
import Dialog from '../../../../base/ui/components/web/Dialog';
import LobbySection from '../../../../lobby/components/web/LobbySection';
import { isEnablingLobbyAllowed } from '../../../../lobby/functions';
/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
export default function SecurityDialog() {
    const e2eeSupported = useSelector((state) => state['features/base/conference'].e2eeSupported);
    const disableLobbyPassword = useSelector((state) => getSecurityUiConfig(state)?.disableLobbyPassword);
    const _isEnablingLobbyAllowed = useSelector(isEnablingLobbyAllowed);
    const isModerator = useSelector(isLocalParticipantModerator);
    const showE2ee = Boolean(e2eeSupported) && isModerator;
    //KRAD - 1665 #12
    // const showE2ee = false;
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'security.title' },
        React.createElement("div", { className: 'security-dialog' }, _isEnablingLobbyAllowed && React.createElement(LobbySection, null))));
}
